import { ChevronLeftIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ContainerCard } from "./cards";
import { cn } from "../../utils/tailwindUtils";

/**
 * Standard full-height shell for report list pages (title + Reactable).
 */
export const ReportPageShell = ({
    title,
    count,
    onBack,
    backTo = "/reports",
    children,
    className,
    headerExtra,
}) => {
    const navigate = useNavigate();

    return (
        <ContainerCard className={cn("font-sans", className)}>
            <div className="flex flex-wrap justify-between items-center gap-3 mb-4 shrink-0">
                <span className="flex gap-2 items-center min-w-0">
                    <ChevronLeftIcon
                        onClick={onBack ?? (() => navigate(backTo))}
                        className="cursor-pointer shrink-0"
                    />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 truncate">
                        {title}
                        {count !== undefined && count !== null && (
                            <span className="text-muted-foreground font-normal ml-1">({count})</span>
                        )}
                    </h1>
                </span>
                {headerExtra}
            </div>
            {children}
        </ContainerCard>
    );
};
